import type { OrdenColumna } from '@/lib/ordenColumna';
import { CaretDown, CaretUp } from '@phosphor-icons/react';

/**
 * Título de columna clickeable para ordenar (mayor a menor → menor a mayor →
 * orden original). Va DENTRO de un <TableHead>, que conserva sus propias clases.
 */
export function TituloOrdenable({
  titulo,
  idx,
  orden,
  onOrdenar,
}: {
  titulo: string;
  idx: number;
  orden: OrdenColumna | null;
  onOrdenar: (idx: number) => void;
}) {
  const activo = orden?.idx === idx;
  return (
    <button
      type="button"
      onClick={() => onOrdenar(idx)}
      className={`inline-flex items-center gap-1 hover:underline ${activo ? 'font-semibold' : ''}`}
      title="Ordenar por esta columna (click: mayor a menor, otro click: menor a mayor, otro: orden original)"
    >
      {titulo}
      {activo &&
        (orden?.dir === 'desc' ? (
          <CaretDown className="h-3 w-3" weight="bold" />
        ) : (
          <CaretUp className="h-3 w-3" weight="bold" />
        ))}
    </button>
  );
}
